import {
  SessionEventsState,
  SessionEventsAction,
  SessionEventsActionType,
  ElectricSessionEvent,
} from "./types";

export const createInitialState = (): SessionEventsState => ({
  isSubscribed: false,
  subscriptionError: null,
  sessionData: null,
  sessionEvents: [],
  isSessionLoading: false,
  isEventsLoading: false,
  sessionId: null,
});

export function sessionEventsReducer(
  state: SessionEventsState,
  action: SessionEventsActionType
): SessionEventsState {
  switch (action.type) {
    case SessionEventsAction.SET_SESSION_ID: {
      return {
        ...state,
        sessionId: action.payload.sessionId,
      };
    }

    case SessionEventsAction.SUBSCRIBE_REQUEST: {
      return {
        ...state,
        isSessionLoading: true,
        isEventsLoading: true,
        subscriptionError: null,
        sessionId: action.payload.sessionId,
      };
    }

    case SessionEventsAction.SUBSCRIBE_SUCCESS: {
      return {
        ...state,
        isSubscribed: true,
        isSessionLoading: false,
        isEventsLoading: false,
        subscriptionError: null,
      };
    }

    case SessionEventsAction.SUBSCRIBE_ERROR: {
      return {
        ...state,
        isSubscribed: false,
        isSessionLoading: false,
        isEventsLoading: false,
        subscriptionError: action.payload.error,
      };
    }

    case SessionEventsAction.SESSION_DATA_UPDATED: {
      return {
        ...state,
        sessionData: action.payload.sessionData,
        isSessionLoading: false,
      };
    }

    case SessionEventsAction.SESSION_EVENTS_UPDATED: {
      return {
        ...state,
        sessionEvents: action.payload.events,
        isEventsLoading: false,
      };
    }

    case SessionEventsAction.UNSUBSCRIBE: {
      return {
        ...createInitialState(),
        sessionId: state.sessionId, // Keep the session ID
      };
    }

    default:
      return state;
  }
}

// Selectors for computed values
export const selectSortedEvents = (events: ElectricSessionEvent[]): ElectricSessionEvent[] => {
  return [...events].sort(
    (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  ); // Oldest first, like the original implementation
};

export const selectIsReady = (state: SessionEventsState): boolean => {
  return state.isSubscribed && !state.isSessionLoading && !state.isEventsLoading;
};
